import {
  getWindow,
  hasClass,
  addClass,
  removeClass,
  selectOne,
  selectMany
} from './utils/dom-utils';

let searchTermFilter = "";
let categoryFilter = "";
let SEARCH_ANALYTICS_TIMEOUT = 5000;


/*
 * Records analytics on what is typed into search box
 */
var recordSearchAnalyticsTimer;

function recordSearchAnalytics(event){
  if (event.type === 'keyup'){
    if(!recordSearchAnalyticsTimer &&  event.target.value.length > 2 ){
      recordSearchAnalyticsTimer = setTimeout(function(){
        recordSearchAnalyticsTimer = null;
        analytics.track("Visitor Searched Intergrations for", {
          site: "marketing",
          search: event.target.value
        });

      }, SEARCH_ANALYTICS_TIMEOUT);

    }
  }

}


/**
 * Determines whether or not a given integration should be visible.
 *
 * @param {String} category     The category the integration falls under.
 * @param {String} displayName  The integration's name.
 *
 * @return {Boolean}
 */
function shouldDisplayIntegration(categoryList, displayName){

  // Show if the filter's not set.
  if (!categoryFilter && !searchTermFilter){
    return true;
  }

  // Hide if the category filter is set but categories don't match.
  if (categoryFilter && categoryList && !categoryList.match(categoryFilter) ){
   return false;
  }

  // Show if the term filter is set and the search term is found in the display name.
  if (searchTermFilter){
    const searchTerm = searchTermFilter.replace(/[^0-9a-z ]/gi, '');
    const searchRegEx = new RegExp("^" + searchTerm, "i", "y");
    return searchRegEx.test(displayName);
  }

  // Otherwise show it.
  return true;
}

/**
 * Handles events on the filter bar and updates each integration's visibility.
 *
 * @param {Object} event  Must contain these keys:
 *                        - type (String): the event type like "click"
 *                        - target (Object): should contain a `dataset` property
 *
 * @return {undefined}
 */
function filter(event) {
  const integrations = selectMany('.integration-preview');
  const filterButtons = selectMany('.integration-filter');
  const noResults = selectOne('.no-results');
  const hiddenIntegrations = [];

  // Update the searchTermFilter on keyup
  if (event.type === 'keyup'){
    searchTermFilter = event.target.value;
  }

  // Update the categoryFilter on click
  if (event.type === 'click'){
    categoryFilter = event.target.dataset.integrationType;
  }

  // Hide or show each integration as appropriate
  integrations.forEach(integration => {
    const categoryList = integration.dataset.categoryList
    const displayName = integration.dataset.displayName
    if (shouldDisplayIntegration(categoryList, displayName)) {
      addClass(integration, 'visible');
    } else {
      removeClass(integration, 'visible');
    }
  });

  // Update the correct button to be "selected"
  filterButtons.forEach(button => {
    if (button.dataset.integrationType === categoryFilter){
      addClass(button, 'type-selected');
    } else {
      removeClass(button, 'type-selected');
    }
  });

  // Collect hidden integrations
  integrations.forEach(integration => {
    if (!hasClass(integration, 'visible')) {
      hiddenIntegrations.push(integration);
    }
  });

  // Show the noResults elem if all integrations are hidden
  if (hiddenIntegrations.length === integrations.length){
    addClass(noResults, 'visible');
  } else{
    removeClass(noResults, 'visible');
  }
}

export default function initIntegrations() {
  const win = getWindow();

  win.addEventListener('load', () => {
    const searchBar = selectOne('#integrations-filter-search');

    if(searchBar){

      const url = win.location.href;
      const regex = /[?&]category=(([^&#]*)|&|#|$)/;
      const results = regex.exec(url);

      // Auto-set the filter based on query string
      if (results && results[1]) {
        filter({ type:'click', target: { dataset: { integrationType: results[1] } } });
      } else {
        filter({ type: 'click', target: { dataset: { integrationType: "" } } });
      }

      // Filter on keyup
      searchBar.addEventListener('keyup', event => filter(event));
      searchBar.addEventListener('keyup', event => recordSearchAnalytics(event));

      // Also filter on click of filter buttons
      selectMany('.integration-filter-wrapper').forEach(button => {
        button.addEventListener('click', event => filter(event));
      });



    }
  });

}




